
import './Ad_admissions_consultant_app.scss';
import * as S from '../../scss/theme';
import fnc from '../../mymod/commFunction';
import HongButton from '../../comm/HongButton';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import HeaderTitle from "../../comm/HeaderTitle";
import Ad_admissions_consultant from './Ad_admissions_consultant';

const Ad_admissions_consultant_app = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [selectedSno, setSelectedSno] = useState(null);
  const [title, setTitle] = useState('아이공 입시컨설턴트 운용계약서 리스트');
  const [isModal_detail, setIsModal_detail] = useState(false);
  const [parentCode, setParentCode] = useState(null);

  useEffect(() => {
    fncSelect_list();
  }, []);


  function fncSelect_list() {
    fnc.sendAxios('/ad_admissions_consultantRoutes/select/consultant_agreement', { }, (res) => {
      if (res && Array.isArray(res)) {
        const newList = getRecords(res);
        setList(newList);
      } else {
        alert('검색에 실패했습니다.');
      }
    });

    function getRecords(res) {
      const records = res.map(item => ({
        sno: item["sno"],
        userCode: item["userCode"],
        userName: item["userName"],
        email: item["email"],
        hp: item["hp"],
        zipCode: item["zipCode"],
        address1: item["address1"],
        address2: item["address2"],
        zipCode_co: item["zipCode_co"],
        address1_co: item["address1_co"],
        address2_co: item["address2_co"],
        bank: item["bank"],
        banknumber: item["banknumber"],
        university_name: item["university_name"],
        university_major: item["university_major"],
        graduate_name: item["graduate_name"],
        graduate_major: item["graduate_major"],
        career: item["career"],
        agreement_terms: item["agreement_terms"],
        sDate: fnc.formatDate2(item["sDate"]),
        useyn: item["useyn"]
      }));
      return records;
    }

  }


  function onClickTestNmSt(item) {
    setParentCode(item.userCode);
    setIsModal_detail(true);
  }

//=========================================
  return (
  <S.Section>
    <HeaderTitle title={title} direction={1} onBackClick={() => navigate(-1)} />
    <div className='Ad_admissions_consultant_app'>

      <section className='sec-main'>
        <table className="table-hong table-main">
          <thead>
            <tr>
              <th>No</th>
              <th>이름</th>
              <th>핸드폰</th>
              <th>이메일</th>
              <th>등록일</th>
              <th>상세</th>
            </tr>
          </thead>
          <tbody>
            {list && list.map((item, index) => (
              <tr key={index}
                className={selectedSno === item.sno ? 'selected' : ''}>
                <td>{index+1}</td>
                <td>{item.userName}</td>
                <td>{item.hp}</td>
                <td>{item.email}</td>
                <td>{item.sDate}</td>
                <td>
                  <HongButton
                    className="btnReport h-btn-dark"
                    onClick={() => onClickTestNmSt(item)}
                  >
                    선택
                  </HongButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

    </div>



    {isModal_detail && (
        <S.Modal_pc>
            <HeaderTitle  title={title} direction={1} onBackClick={() => setIsModal_detail(false)} />
            <section className="">
                <Ad_admissions_consultant parentCode={parentCode} />
            </section>              
        </S.Modal_pc>
    )}

  </S.Section>
  );
};

export default Ad_admissions_consultant_app;